export default __webpack_public_path__ + "static/media/selection.37acde6f.svg";